<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   export default {
      page: {
         title: "Order Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Order Details",
            items: [
               {
                  text: "Orders",
                  href: "/orders",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            order: {},
            fuels: [],
            meter_images: [],
            ratings: [],

            customer_order_id: '',
            
            marker: { position: { lat: null, lng: null } },
            center: { lat: null, lng: null },
            current_place: null,

            mapOptions: {
               disableDefaultUI: true,
            },         

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchOrder();
      },

      methods: {

         fetchOrder() {

            this.getToken();
            let url = "fuelstation/fuel_station/order/details?id=" + this.$route.params.id;          
            this.loading = true;
            
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) {
                     var responseData = res.data.data;
                     console.log(responseData);
                     
                     this.order = responseData.Order_details;
                     this.fuels = responseData.fuels;
                     this.meter_images = responseData.meter_images;
                     this.ratings = responseData.ratings;
                     

                     this.marker.position.lat = parseFloat(this.order.latitude);
                     this.marker.position.lng = parseFloat(this.order.longitude);

                     this.center.lat = parseFloat(this.order.latitude);
                     this.center.lng = parseFloat(this.order.longitude);

                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('sigofuel_fuelstation')) {
               var sigofuel_fuelstation =  JSON.parse(localStorage.getItem('sigofuel_fuelstation'));
               if(sigofuel_fuelstation.token) {
                  this.token = sigofuel_fuelstation.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         }, 
         
         download(order) {
         this.customer_order_id = order.customer_order_id;
         
         let url = "fuelstation/fuel_station/order/invoice?id=" + this.customer_order_id;   

         const config = {
            headers: {
               "Content-type": "application/json",
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
            responseType: "arraybuffer",
         };
      
         this.getToken();

         this.$axios
         .get(url, config)
         .then((response) => {
            //console.log(response);
            let blob = new Blob([response.data], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
         
            let filename = "invoice" + "-" + this.customer_order_id + ".pdf";


            link.download = filename;
            link.click();
                  
         })
         .catch((error) => {
         console.log(error);
         console.log(error.response);
         if (error.response) {
         if(error.response.status == 422) {               
            if (error.response.data) {
               this.errors = error.response.data.message;
            } 
            this.$swal("", error.response.statusText, "error");
            
         } else if(error.response.status == 500) {
            this.$swal("", error.response.statusText, "error");
         } 
         else if(error.response.status == 401) {
            this.$swal("", error.response.statusText, "error");
            this.$router.push({ name: "login" });
         } else {
            this.$swal("", "Something went wrong", "error");
         }
         } else {
         this.$swal("", error.message, "error");
         }

         });
         //.finally(() => (this.loading = false));
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        <button variant="primary" v-if="order.order_status==5" class="btn btn-primary float-end me-2" @click="download(order)">Invoice</button>
                        <!-- <b-button v-if="order.order_status==5" variant="primary"  class="btn btn-primary float-end me-2">Invoice</b-button> -->

                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-6">

                        <b-card header-class="bg-transparent border-light" class="border border-light">  
                           <h4 class="font-size-15 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Customer Details</h4>

                           <div class="row">
                              <div class="col-12">
                                 <b-media class="mb-1">
                                    <template v-slot:aside>
                                       <img v-if="order.customer_image" :src="$image_url + order.customer_image" alt="" class="avatar-md rounded-circle">
                                       <img v-else src="@/assets/images/no-user.jpg" alt class="avatar-md rounded-circle"/>
                                       <br>
                                    </template>
                                    <b-media-body class="ms-3">
                                       <h5 class="mt-1 mb-1">
                                          <span v-if="order.customer_name_en">{{order.customer_name_en}}</span>
                                          <span v-else>{{order.customer_name_so}}</span>
                                       </h5>
                                       <p>
                                          {{order.customer_country_code}} {{order.customer_mobile}}<br>
                                          {{order.customer_email}}
                                       </p>
                                    </b-media-body>
                                 </b-media>
                              </div>
                           </div> 
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="order.drivers">  
                           <h4 class="font-size-15 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Driver Details</h4>

                           <div class="row">
                              <div class="col-12">
                                 <b-media class="mb-1">
                                    <template v-slot:aside>
                                       <img v-if="order.driver_image" :src="$image_url + order.driver_image" alt="" class="avatar-md rounded-circle">
                                       <img v-else src="@/assets/images/no-user.jpg" alt class="avatar-md rounded-circle"/>
                                       <br>
                                    </template>
                                    <b-media-body class="ms-3">
                                       <h5 class="mt-1 mb-1">
                                          <span v-if="order.driver_name_en">{{order.driver_name_en}}</span>
                                          <span v-else>{{order.driver_name_so}}</span>
                                       </h5>
                                       <p>
                                          {{order.driver_country_code}} {{order.driver_mobile}}<br>
                                          {{order.driver_email}}
                                       </p>
                                    </b-media-body>
                                 </b-media>
                              </div>
                           </div> 
                        
                        </b-card>                

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="meter_images.length">  
                           <h4 class="font-size-15 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Meter Reading</h4>

                           <div class="row">
                              <div class="col-12" v-for="image in meter_images" :key="image.id">
                                 <img class="img-fluid" :src="$image_url + image.meter_image_url"/>
                              </div>
                           </div> 
                        
                        </b-card>  

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="order.latitude && order.longitude">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Location</h4>
                           <b-row>                          

                              <b-col  md="12">
                                 <GmapMap  v-if="order.latitude && order.longitude"
                                 :center="center"
                                 :zoom="18"
                                 map-style-id="roadmap"
                                 :options="mapOptions"
                                 style="width: 100%; height: 300px"
                                 ref="mapRef">                              
                                    <GmapMarker
                                       :position="marker.position"
                                       :clickable="false"
                                       :draggable="false"
                                    />
                              </GmapMap>        
                              </b-col>

                           </b-row>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="ratings.length">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Customer Review</h4>
                           <b-row>    
                              <b-col lg="12"  v-for="rating in ratings" :key="rating.id">
                                 <p class="text-muted">
                                   <i  v-for="(i) in rating.star_rating" :key="i" class="bx bxs-star text-warning"></i>
                                   <i  v-for="(j) in (5 - parseInt(rating.star_rating))" :key="j" class="bx bxs-star"></i>
                                   <span class="ms-3 font-size-18">{{rating.star_rating}}</span>
                                 </p>
                                 <p>{{rating.review}}</p>
                              </b-col>
                           </b-row>
                        </b-card>

                     </div>

                     <div class="col-lg-7 col-md-6">
                         
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Other Details</h4>                             

                           <div class="table-responsive ">
                                 <table class="table mb-0 w-100">
                                    <tbody>
                                       <tr>
                                          <th>Order ID</th>
                                          <th>:</th>
                                          <td>#{{order.customer_order_id}}</td>
                                       </tr> 

                                       <!-- <tr>
                                          <th>Fuel</th>
                                          <th>:</th>
                                          <td>Diesel</td>
                                       </tr> -->

                                       <tr>
                                          <th>Order Type</th>
                                          <th>:</th>
                                          <td>
                                             <span v-if="order.order_type==1">Normal</span>
                                             <span v-if="order.order_type==2">Schedule delivery</span>
                                          </td>
                                       </tr>

                                       <tr>
                                          <th>Created by</th>
                                          <th>:</th>
                                          <td>
                                             <span v-if="order.customer_order_added_by==1">Self</span>
                                             <span v-if="order.customer_order_added_by==2">Subadmin</span>
                                             <span v-if="order.customer_order_added_by==3">Customer</span>
                                             <span v-if="order.customer_order_added_by==4">Fuel Station</span>
                                          </td>
                                       </tr>                                     
                                       <tr>
                                          <th>Payment Type</th>
                                          <th>:</th>
                                          <td>
                                             <span v-if="order.payment_type==1">Mobile Payment</span>
                                             <span v-if="order.payment_type==2">Cash Payment</span>
                                          </td>
                                       </tr>

                                       <tr>
                                          <th>Status</th>
                                          <th>:</th>
                                          <td>
                                             <span v-if="order.order_status==0">Requested</span>
                                             <span v-if="order.order_status==1">Pending</span>
                                             <span v-if="order.order_status==2">Accepted</span>
                                             <span v-if="order.order_status==3">Ongoing</span>
                                             <span v-if="order.order_status==4">Scheduled</span>
                                             <span v-if="order.order_status==5">Delivered</span>
                                             <span v-if="order.order_status==6">Cancelled</span>
                                             <span v-if="order.order_status==7">Missed</span>
                                          </td>
                                       </tr>

                                       <tr v-if="order.status==2 || order.status==3 || order.status==5">
                                          <th>Driver Accepted Date & Time</th>
                                          <th>:</th>
                                          <td>{{order.driver_accepted_at | formatDateTime}}</td>
                                       </tr>

                                       <tr v-if="order.status==5">
                                          <th>Delivered Date & Time</th>
                                          <th>:</th>
                                          <td>{{order.accepted_at | formatDateTime}}</td>
                                       </tr>

                                       <tr>
                                          <th>Address</th>
                                          <th>:</th>
                                          <td><p class="w-200px">{{order.address}}</p></td>
                                       </tr>

                                       <tr>
                                          <th>Latitude</th>
                                          <th>:</th>
                                          <td>{{order.latitude}}</td>
                                       </tr> 

                                       <tr>
                                          <th>Longitude</th>
                                          <th>:</th>
                                          <td>{{order.longitude}}</td>
                                       </tr>  

                                       <tr>
                                          <th>Special Instructions</th>
                                          <th>:</th>
                                          <td><p class="w-200px">{{order.special_instructions}}</p></td>
                                       </tr> 

                                       <tr>
                                          <th>Created on</th>
                                          <th>:</th>
                                          <td>{{order.converted_created_at | formatDateTime }}</td>
                                       </tr>  
                                    </tbody>     
                                 </table>
                           </div>
                           
                        </b-card>
                        <!-- end card -->

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Order Summary</h4>                             

                           <div class="table-responsive ">
                                 <table class="table mb-0 w-100">
                                    <tbody>
                                       <tr v-for="fuel in fuels" :key="fuel.id">
                                          <th>{{fuel.quantity}} litre {{fuel.fuel_en}} (${{fuel.price}}x{{fuel.quantity}})</th>
                                          <th>:</th>
                                          <td class="text-right">${{fuel.amount}}</td>
                                       </tr>

                                       <tr>
                                          <th>Total Fuel Price</th>
                                          <th>:</th>
                                          <td class="text-right">${{order.fuel_quantity_price}}</td>
                                       </tr>                                       
                                       <tr>
                                          <th>Delivery Charge </th>
                                          <th>:</th>
                                          <td class="text-right">${{order.delivery_charge}}</td>
                                       </tr>

                                       <tr>
                                          <th>Promo Discount</th>
                                          <th>:</th>
                                          <td class="text-right">${{order.promotion_discount}}</td>
                                       </tr>

                                       <tr>
                                          <th>Tax</th>
                                          <th>:</th>
                                          <td class="text-right">${{order.tax}}</td>
                                       </tr>

                                       <tr>
                                          <th>Other Charges</th>
                                          <th>:</th>
                                          <td class="text-right">${{order.other_charges}}</td>
                                       </tr>

                                       <tr>
                                          <th>Total</th>
                                          <th>:</th>
                                          <th class="text-right">${{order.total}}</th>
                                       </tr>

                                       <tr>
                                          <th>Amount Commission (For Admin)</th>
                                          <th>:</th>
                                          <td class="text-right">${{order.amount_commission}}</td>
                                       </tr>

                                       <tr>
                                          <th>Delivery Charge Commission (For Admin)</th>
                                          <th>:</th>
                                          <td class="text-right">${{order.delivery_charge_commission}}</td>
                                       </tr>

                                       <tr>
                                          <th>Total Earnings (For Admin)</th>
                                          <th>:</th>
                                          <th class="text-right">${{order.Total_earnings}}</th>
                                       </tr>

                                    </tbody>
                                 </table>
                           </div>
                        </b-card> 

                        <!-- <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-transparent py-2 mb-3">Driver Assigned Logs</h4>                             

                           <div class="table-responsive ">
                              <table class="table mb-0 w-100">
                                 <thead class="table-light">
                                    <tr>
                                       <th>SI No.</th>
                                       <th>Driver</th>
                                       <th>Assigned Date & Time</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr> 
                                       <td>1</td>
                                       <td>Mohammad Ali</td>
                                       <td>22 Aug 2022, 12:45 pm</td>
                                    </tr>
                                    <tr> 
                                       <td>2</td>
                                       <td>Nazrudhin Shah</td>
                                       <td>22 Aug 2022, 01:30 pm</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </b-card> -->

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

   </Layout>
</template>
